// Kill Sheet — Onboarding helper (Phase 1.5).
//
// Pure module. No React, no DOM, no storage. Exists so the next-kind
// suggestion logic can be unit-tested in Node and so KillSheetEditor.jsx
// doesn't grow further.
//
// Canonical creation order — chosen to match IWCF intuition:
//   well       → anchors depths/TVD for everything else
//   casing     → defines pressure boundaries (MAASP)
//   bha        → consumes well + casing geometry
//   mud        → consumes well TVD for gradient checks
//   pump       → consumes mud + bha for stroke calcs
//   opstate    → consumes all of the above
export const ONBOARDING_ORDER = ["well", "casing", "bha", "mud", "pump", "opstate"];

export function isKindBound(session, kind) {
  return !!(session && session.refs && session.refs[kind] && session.refs[kind].id);
}

export function countBound(session) {
  return ONBOARDING_ORDER.filter((k) => isKindBound(session, k)).length;
}

/**
 * Returns the next profile kind the user should create, following
 * ONBOARDING_ORDER. Returns null when every kind in the canonical order is
 * already bound. Kinds outside the canonical order are ignored — the
 * suggestion strip cares only about the six kinds required for an IWCF
 * kill sheet.
 */
export function nextUnboundKind(session) {
  for (const k of ONBOARDING_ORDER) {
    if (!isKindBound(session, k)) return k;
  }
  return null;
}

// Display labels — short, singular, fits inline strip on mobile.
export const KIND_DISPLAY_LABEL = {
  well:    "Well",
  casing:  "Casing",
  bha:     "BHA",
  mud:     "Mud",
  pump:    "Pump",
  opstate: "Operational State",
};
